import { OLRVersion } from '@common';
import { AppVariant, VariantConfig } from '@config';
import { CountryIsoNumber } from '@i18n';
import { appRoutes as gbAmdeaRoutes } from '../routes/app-amdea.routes';
import { appRoutes as ieRoutes } from '../routes/app-ie.routes';
import { appRoutes as gbPromoRoutes } from '../routes/app-promo.routes';
import { appRoutes as gbSdaRoutes } from '../routes/app-sda.routes';
import { appRoutes as gbSidedoorRoutes } from '../routes/app.routes';

export const VARIANT_CONFIGS: Record<AppVariant, VariantConfig> = {
  [AppVariant.GbSidedoor]: {
    olrVersion: OLRVersion.Sidedoor,
    enableTracking: true,
    routes: gbSidedoorRoutes,
    baseHref: '/register/',
  },
  [AppVariant.GbSidedoorAmdea]: {
    olrVersion: OLRVersion.SidedoorAmdea,
    enableTracking: false,
    routes: gbAmdeaRoutes,
    baseHref: '/amdea/',
  },
  [AppVariant.GbSidedoorSda]: {
    olrVersion: OLRVersion.SidedoorSDA,
    enableTracking: true,
    routes: gbSdaRoutes,
    baseHref: '/small-domestic-appliances/register',
  },
  [AppVariant.GbSidedoorPromo]: {
    olrVersion: OLRVersion.SidedoorPromo,
    enableTracking: true,
    routes: gbPromoRoutes,
    baseHref: '/promo/register/',
  },
  [AppVariant.IeSidedoor]: {
    olrVersion: OLRVersion.SidedoorROI,
    countryIsoNumber: CountryIsoNumber.Ireland,
    enableTracking: false,
    routes: ieRoutes,
    baseHref: '/ie/register',
  },
};
